
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as agendaZWEbj8mUMczi2YaOXPRjxHpc8pC9w55aRURgaJsbWVAMeta } from "/opt/build/repo/pages/agenda.vue?macro=true";
import { default as contactUtUBN6u09MOBXpCX2V4MTnIvODrHK3on_Sjbujn1zJsMeta } from "/opt/build/repo/pages/contact.vue?macro=true";
import { default as collectifqwyp7NnUVkOIus5DESH9bgJOviJLiFO6R8woZ19RCEsMeta } from "/opt/build/repo/pages/collectif.vue?macro=true";
import { default as indexQYBbwqmeFTKzOeFn46eoFndAdLwT1cl0WWM2kbgbDLcMeta } from "/opt/build/repo/pages/about/index.vue?macro=true";
import { default as _91_46_46_46slug_93rMhfzX4pH1z53ZCEzwyjCDsCOfsse6SwNx87WIUgIyYMeta } from "/opt/build/repo/pages/about/[...slug].vue?macro=true";
import { default as indexQ0hG7PpsA7xOIIP7Qub0sGb6lshUaR756uP5pLWRXdsMeta } from "/opt/build/repo/pages/spectacles/index.vue?macro=true";
import { default as _91_46_46_46slug_93prg_4JTYepeKVIu3I0Hka_4519oG27rnXj5fUVcafmp7MMeta } from "/opt/build/repo/pages/spectacles/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "agenda",
    path: "/agenda",
    component: () => import("/opt/build/repo/pages/agenda.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "collectif",
    path: "/collectif",
    component: () => import("/opt/build/repo/pages/collectif.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/build/repo/pages/about/index.vue")
  },
  {
    name: "about-slug",
    path: "/about/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/about/[...slug].vue")
  },
  {
    name: "spectacles",
    path: "/spectacles",
    component: () => import("/opt/build/repo/pages/spectacles/index.vue")
  },
  {
    name: "spectacles-slug",
    path: "/spectacles/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/spectacles/[...slug].vue")
  }
]